import Delete from "assets/Icon_Action_03.png";
import Update from "assets/Icon_Action_02.png";
import View from "assets/Icon_Action_01.png";
import { lazyWithRetry } from "helpers/lazyWithRetry";
import { SupplierFeedbackRow } from "./SupplierFeedbackList.types";
import DeleteModal from "components/helpers/DeleteModal";
import { CrudItems, CrudOptions } from "components/Category/CrudMenu";
import { endpoints } from "config";

const SupplierFeedback = lazyWithRetry(
  () => import("pages/SupplierFeedback/SupplierFeedback/SupplierFeedback")
);

// --- CRUD item creators ---

/**
 * Creates the create menu item for supplier feedback types
 * @returns CRUD item for creating a new supplier feedback type
 */
function createSupplierFeedbackTypeCreateItem() {
  return {
    icon: View,
    imgAltText: "Create",
    permissionsKey: "create",
    title: "Add new supplier feedback",
    menuCode: "CREATE" as CrudOptions,
    showInMultiSelect: false,
    content: (onDone: () => void, selectedData: SupplierFeedbackRow[], menu: any) => (
      <SupplierFeedback
        selectedData={selectedData}
        onDone={onDone}
        idFromRowOption={menu.selectedId}
        actionType="create"
        submitButtonText="Add"
      />
    ),
    inRightPanel: true,
    isDisabled: false,
    notInMenus: true,
  };
}

/**
 * Creates the update menu item for supplier feedback types
 * @returns CRUD item for updating an existing supplier feedback type
 */
function createSupplierFeedbackTypeUpdateItem() {
  return {
    icon: Update,
    imgAltText: "Update",
    permissionsKey: "edit",
    title: "Update supplier feedback",
    menuCode: "UPDATE" as CrudOptions,
    showInMultiSelect: false,
    content: (onDone: () => void, selectedData: SupplierFeedbackRow[], menu: any) => (
      <SupplierFeedback
        selectedData={selectedData}
        onDone={onDone}
        idFromRowOption={menu.selectedId}
        actionType="edit"
        submitButtonText="Update"
      />
    ),
    inRightPanel: true,
    isDisabled: false,
  };
}

/**
 * Creates the delete menu item for supplier feedback types
 * @returns CRUD item for deleting one or more supplier feedback types
 */
function createSupplierFeedbackTypeDeleteItem() {
  return {
    icon: Delete,
    imgAltText: "Delete",
    permissionsKey: "delete",
    title: (data: SupplierFeedbackRow[]) =>
      data.length <= 1 ? "Delete supplier feedback" : `Delete ${data.length} supplier feedback`,
    menuCode: "DELETE" as CrudOptions,
    showInMultiSelect: true,
    content: (onActionComplete: () => void, selectedData: SupplierFeedbackRow[], menu: any) => (
      <DeleteModal
        url={endpoints.supplierFeedback.delete}
        noun="supplier feedback"
        selectedIds={selectedData.map((d) => d.supplierFeedbackTypes__Id)}
        renderListItem={(data: SupplierFeedbackRow) => {
          return (
            <li>{`${data.supplierFeedbackTypes__Id}: ${data.supplierFeedbackTypes__FeedbackName}`}</li>
          );
        }}
        selectedData={selectedData}
        open={menu.currentMenu === "DELETE"}
        close={onActionComplete}
        idFromRowOption={menu.selectedId}
      />
    ),
    inRightPanel: false,
    isDisabled: false,
  };
}

/**
 * Gets all CRUD items for supplier feedback types
 * @returns Array of CRUD items for supplier feedback type operations
 */
export function getCrudItems(): CrudItems<SupplierFeedbackRow> {
  return [
    createSupplierFeedbackTypeCreateItem(),
    createSupplierFeedbackTypeUpdateItem(),
    createSupplierFeedbackTypeDeleteItem(),
  ];
}
